import styled, { css, keyframes } from "styled-components";

const glow = keyframes`
  0%,
  100% {
    box-shadow: 0 0 0 0 var(--glow-color);
  }
  50% {
    box-shadow: 0 0 18px 0 var(--glow-color);
  }
`;

const shineBorder = keyframes`
  0% {
    background-position: 0 0, 0% 50%;
  }
  100% {
    background-position: 0 0, 200% 50%;
  }
`;

export const Card = styled.div`
  background-color: #ffff;
  border-radius: 8px;
  filter: drop-shadow(0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08));
`;

export const Header = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  height: 4.5rem;
  font-weight: 600;
  padding-left: 0.75rem;
  padding-right: 1rem;
  font-size: 1.25rem;
  user-select: none;
  justify-content: space-between;
`;

export const ContentCard = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Iteration = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  .divisor-line {
    width: 80%;
    height: 3px;
    margin: 0 auto;
    border-radius: 999px;
    background-color: #eaecf0;
  }
`;
/**
 * @typedef {Object} GridLayerProps
 * @property {number} [columns]
 * @property {string} [gradientColor]
 */
/** @type {import('styled-components').StyledComponent<'div', any, GridLayerProps, never>} */
export const GridLayer = styled.div`
  --glow-color: ${(props) => props.gradientColor || ""};
  position: relative;
  z-index: 0;
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns || 4}, 1fr);
  gap: 1rem;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 1px;
  overflow-x: auto;
  overflow-y: hidden;
  clip-path: inset(0 round 12px);

  background: linear-gradient(#fff, #fff) padding-box,
    ${(props) =>
        props.gradientColor
          ? css`
            linear-gradient(
              120deg,
              transparent,
              ${props.gradientColor},
              transparent
            )
          `
          : css`
            linear-gradient(
              120deg,
              transparent,
              rgba(17, 128, 82, 0.6),
              transparent
            )
          `}
      border-box;

  background-size: 100% 100%, 260% 260%;
  border: 1px solid transparent;
  animation: ${shineBorder} 6s linear infinite;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: radial-gradient(circle, var(--glow-color), transparent 65%);
    opacity: 0.45;
    filter: blur(10px);
    transform: scale(1);
    transform-origin: center;
    animation: ${glow} 3.5s ease-in-out infinite;
    pointer-events: none;
    z-index: -1;
    clip-path: inset(0 round inherit);
  }

  .column-item {
    position: relative;
    background-color: #fff;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    box-shadow: 0 4px 12px rgba(17, 128, 82, 0.08);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 12rem;
  }

  .column-title {
    color: #a9aeb4;
  }

  .column-content {
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    height: 100%;
    gap: 0.5rem;
  }

  .column-content img {
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
  }

  .rdm-description {
    grid-column: 1 / -1;

    p {
      white-space: pre-line;
    }
  }

  .percents {
    color: #118052;
    font-weight: 600;
  }

  .positive {
    color: rgb(0, 36, 241);
    font-weight: 600;
  }

  .negative {
    color: rgb(217, 21, 21);
    font-weight: 600;
  }

  .rank {
    background-color: #40e5a0;
    font-weight: 600;
    width: fit-content;
    padding: 0.25rem 0.5rem;
  }
`;
